(function() {
    'use strict';
    angular.module('wbUtilities', ['LocalStorageModule', 'ngSha']);
})();
